var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBubble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.5H11M5 7.5H8M1.5 8.50623C1.5 9.57362 2.24894 10.5027 3.30497 10.658C4.05731 10.7686 4.81816 10.853 5.58657 10.9103C5.82003 10.9277 6.03345 11.0502 6.16331 11.245L8 14L9.83667 11.245C9.96653 11.0502 10.18 10.9278 10.4134 10.9104C11.1818 10.8531 11.9427 10.7687 12.695 10.6581C13.751 10.5028 14.5 9.5737 14.5 8.5063V4.4937C14.5 3.42631 13.751 2.49722 12.695 2.34196C11.1627 2.11668 9.59507 2 8.00019 2C6.40517 2 4.83741 2.1167 3.30498 2.34202C2.24894 2.49729 1.5 3.42637 1.5 4.49376V8.50623Z",
    stroke: "#6B6B6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble);
export default __webpack_public_path__ + "static/media/chat-bubble.8e340575de9f1955978866bd81879215.svg";
export { ForwardRef as ReactComponent };